var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrompt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85883 10.1297L3.03333 10.79L3.02664 10.7953C2.57989 11.1525 2.35585 11.3316 2.16721 11.3316C2.08571 11.3317 2.00524 11.3134 1.9318 11.278C1.85837 11.2426 1.79386 11.1912 1.74308 11.1274C1.625 10.9795 1.625 10.6908 1.625 10.1134V3.89996C1.625 3.29329 1.625 2.98996 1.74308 2.75813C1.84694 2.55429 2.01267 2.38857 2.2165 2.28471C2.44833 2.16663 2.75167 2.16663 3.35833 2.16663H9.64167C10.2483 2.16663 10.5517 2.16663 10.783 2.28471C10.987 2.38848 11.1529 2.55421 11.2569 2.75813C11.375 2.98942 11.375 3.29275 11.375 3.89833V8.01879C11.375 8.62329 11.375 8.92663 11.2569 9.15846C11.1531 9.36229 10.9873 9.52802 10.7835 9.63188C10.5522 9.74996 10.2489 9.74996 9.64329 9.74996H4.94108C4.71575 9.74996 4.60363 9.74996 4.49583 9.77217C4.39942 9.79203 4.30769 9.82417 4.22067 9.86859C4.12371 9.91788 4.0365 9.98721 3.86425 10.1253L3.85883 10.1297Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrompt);
export default __webpack_public_path__ + "static/media/Prompt.be8018102bf27fba25b22fb17de7df40.svg";
export { ForwardRef as ReactComponent };